import React from "react";
import { formatterCurrency } from "../../../../utils/formatters/formatter";
import { LoanTypes } from "../../../../services/loan/type.constansts";

const ViewInfo = ({ url }: { url: string | null }) => {
  if (!url) return null
  return (<span onClick={() => { window.open(url, '_blank'); }}>{"View info ->"}</span>)
};

const SAMPLE_ENTITY_NAME = "Sample Entity"

export const contactData = (salesforceData: any) => ({
  label: 'Partners and contacts',
  content: [
    (
      salesforceData?.entity && salesforceData?.entity?.name !== SAMPLE_ENTITY_NAME ?
        { field: 'Entity', value: <React.Fragment>{salesforceData.entity.name} <ViewInfo url={salesforceData.entity.url} /></React.Fragment> }
        :
        { field: 'Entity', value: <React.Fragment><i>Waiting for borrower</i> <ViewInfo url={null} /></React.Fragment> }
    ),
    (
      salesforceData?.guarantors && salesforceData?.guarantors.length && salesforceData?.entity?.name !== SAMPLE_ENTITY_NAME ?
        { field: 'Guarantors', value: <React.Fragment>{salesforceData.guarantors[0].name} <ViewInfo url={salesforceData.guarantors[0].url} /></React.Fragment> }
        :
        { field: 'Guarantors', value: <React.Fragment><i>Waiting for borrower</i> <ViewInfo url={null} /></React.Fragment> }
    ),
    { field: 'Main loan contact', value: <React.Fragment>{salesforceData?.mainLoanContact?.name} <ViewInfo url={salesforceData?.mainLoanContact?.url} /></React.Fragment> },
    { field: 'Title agent', value: <React.Fragment>{salesforceData?.titleAgent?.name} <ViewInfo url={salesforceData?.titleAgent?.url} /></React.Fragment> },
    { field: 'Insurance agent', value: <React.Fragment>{salesforceData?.insuranceAgent?.name} <ViewInfo url={salesforceData?.insuranceAgent?.url} /></React.Fragment> },
    { field: 'Payoff contact', value: <React.Fragment>{salesforceData?.payoffContact?.name} <ViewInfo url={salesforceData?.payoffContact?.url} /></React.Fragment> }
  ],
})

export const contentBoxes = (loanSelected: any) => {
  let originationFeePercent = loanSelected?.salesforceData?.fees?.originationFeePercent
  let originationFee = loanSelected?.salesforceData?.fees?.originationFee

  if (!originationFeePercent) {
    originationFeePercent = 2
    originationFee = ((loanSelected?.loanData?.selectedOption?.totalLoanAmount || 0) * (originationFeePercent / 100))
  }

  const data = {
    /* Loan Details */
    purpose: loanSelected?.purpose,
    type: loanSelected?.type,
    amortization: loanSelected?.salesforceData?.details?.amortization ? loanSelected?.salesforceData?.details?.amortization : (loanSelected?.type === 'Rental' ? '30 year' : 'Interest Only'),
    lien: '1st Position',

    /* Property Details */
    propertyType: loanSelected?.salesforceData?.property?.propertyType ? loanSelected?.salesforceData?.property?.propertyType : loanSelected?.loanData?.['What kind of property is it?'],
    unitCount: loanSelected?.salesforceData?.property?.unitCount,

    /* Budget And Valuation */
    purchasePrice: formatterCurrency(loanSelected?.salesforceData?.budget?.purchasePrice || loanSelected?.loanData?.price),

    asIsValue: formatterCurrency(loanSelected?.salesforceData?.budget?.asIsValue || loanSelected?.loanData?.price),
    appraiserAsIsValue: loanSelected?.salesforceData?.budget?.appraiserAIV ? formatterCurrency(loanSelected?.salesforceData?.budget?.appraiserAIV) : 'Awaiting appraisal',
    currentLoanBalance: formatterCurrency(loanSelected?.salesforceData?.budget?.currentLoanBalance || loanSelected?.loanData?.currentLoanBalance),

    estimatedARV: formatterCurrency(loanSelected?.salesforceData?.budget?.estimatedARV || loanSelected?.loanData?.afterRepairValue),
    appraiserARV: loanSelected?.salesforceData?.budget?.appraiserARV ? formatterCurrency(loanSelected?.salesforceData?.budget?.appraiserARV) : 'Awaiting appraisal',
    constructionReserve: formatterCurrency(loanSelected?.salesforceData?.budget?.constructionReserve || loanSelected?.loanData?.constructionBudget),
    rehabBudget: formatterCurrency(loanSelected?.salesforceData?.budget?.rehabBudget || loanSelected?.loanData?.constructionBudget),
    loanToCost: loanSelected?.salesforceData?.budget?.loanToCost ? loanSelected?.salesforceData?.budget?.loanToCost : `${((loanSelected?.loanData?.selectedOption?.ltc) * 100).toFixed(2)}%`,
    advanceAmount: loanSelected?.salesforceData?.budget?.advanceAmount ? formatterCurrency(loanSelected?.salesforceData?.budget?.advanceAmount) : formatterCurrency(loanSelected?.loanData?.selectedOption?.totalLoanAmount - (loanSelected?.loanData?.constructionBudget ?? 0)),

    /* Rental */
    monthlyRent: formatterCurrency(loanSelected?.salesforceData?.budget?.monthlyRent || loanSelected?.loanData?.monthlyRent),
    appraisalMonthlyRent: loanSelected?.salesforceData?.budget?.appraisalMonthlyRent ? formatterCurrency(loanSelected?.salesforceData?.budget?.appraisalMonthlyRent) : 'Awaiting appraisal', // <-- AGREGADO
    annualTaxes: formatterCurrency(loanSelected?.salesforceData?.budget?.annualTaxes || loanSelected?.loanData?.annualTaxes),
    annualInsurance: formatterCurrency(loanSelected?.salesforceData?.budget?.annualInsurance || loanSelected?.loanData?.annualInsurance),
    annualHoa: formatterCurrency(loanSelected?.salesforceData?.budget?.annualHoa || loanSelected?.loanData?.annualHoa),
    dscr: loanSelected?.salesforceData?.budget?.dscr || loanSelected?.loanData?.selectedOption?.dscr,


    /* Fees */
    originationFee: `${formatterCurrency(originationFee)} (${(originationFeePercent).toFixed(2)}%)`,
    processingFee: formatterCurrency(loanSelected?.salesforceData?.fees?.processingFee || 0),
    proRatedInterest: formatterCurrency(loanSelected?.salesforceData?.fees?.proRatedInterest || 0),
    thirdPartyCosts: "Contact closing agent",
    prepay: loanSelected?.salesforceData?.fees?.prepay || "3 Months",
    assignmentFee: formatterCurrency(loanSelected?.salesforceData?.fees?.assignmentFee || 0),
    floodCertificationFee: formatterCurrency(loanSelected?.salesforceData?.fees?.floodCertificationFee || 0),
    creditAndBackgroundCheckFee: formatterCurrency(loanSelected?.salesforceData?.fees?.creditAndBackgroundCheckFee || 0),
    miscFees: formatterCurrency(loanSelected?.salesforceData?.fees?.miscFees || 0),
    overnightDeliveryFee: formatterCurrency(loanSelected?.salesforceData?.fees?.overnightDeliveryFee || 0),
    lenderLegalFee: formatterCurrency(loanSelected?.salesforceData?.fees?.lenderLegalFee || 0),
    insurancePremiumToBeCollected: formatterCurrency(loanSelected?.salesforceData?.fees?.insurancePremiumToBeCollected || 0),
    totalLoanFees: formatterCurrency(loanSelected?.salesforceData?.fees?.totalLoanFees || 0),
  }

  return ([
    {
      label: 'Loan Details',
      content: [
        { field: 'Loan Purpose', value: data.purpose },
        { field: 'Loan Type', value: data.type },
        { field: 'Amortization', value: data.amortization },
        { field: 'Lien', value: data.lien },
      ],
    },
    {
      label: 'Property Details',
      content: [
        { field: 'Property Type', value: data.propertyType },
        ...(data.type === LoanTypes.RENTAL ?
          [{ field: 'Unit count', value: <React.Fragment>{data.unitCount} <span>{"View unit info ->"}</span></React.Fragment> }]
          :
          []
        )
      ],
    },
    {
      label: 'Budget and Valuation',
      content: [
        ...(
          data.purpose === "Purchase" ?
            [
              { field: 'Purchase Price', value: data.purchasePrice },
            ]
            :
            [
              { field: 'As-is-value', value: data.asIsValue, extra: { field: 'Appraiser’s as-is-value', value: data.appraiserAsIsValue } },
              { field: 'Current Loan Balance', value: data.currentLoanBalance },
            ]
        ),
        ...(
          data.type === "Fix and Flip" ?
            [
              { field: 'Estimated ARV', value: data.estimatedARV, extra: { field: 'Appraiser’s ARV', value: data.appraiserARV } },
              { field: 'Construction reserve', value: data.constructionReserve },
              { field: 'Rehab Budget', value: data.rehabBudget },
            ]
            :
            []
        ),
        ...(
          data.type === "Fix and Flip" ?
            [
              { field: 'Loan-to-cost', value: data.loanToCost },
              { field: 'Advance amount', value: data.advanceAmount },
            ]
            :
            []
        ),
        ...(
          data.type === "Rental" ?
            [
              { field: 'Monthly Rent', value: data.monthlyRent, extra: { field: 'Appraiser’s monthly rent', value: data.appraisalMonthlyRent } },
              { field: 'Annual Taxes', value: data.annualTaxes },
              { field: 'Annual Insurance', value: data.annualInsurance },
              { field: 'Annual HOA', value: data.annualHoa },
              { field: 'DSCR', value: data.dscr },
            ]
            :
            []
        )
      ],
    },
    {
      label: 'Fees',
      content: [
        { field: 'Origination fee', value: data.originationFee },
        { field: 'Processing fee', value: data.processingFee },
        { field: 'Third-party costs', value: data.thirdPartyCosts },
        { field: 'Prepay', value: data.prepay },
        { field: 'Lender legal fee', value: data.lenderLegalFee },
      ],
    },
  ])
}